/// <reference path="../../ng-services/chat.service.ts"/>

import { MeetingsStore } from '../../ng-services/meetings.store';

(function () {
    class ChatFullscreenComponent {
        static $inject = ['$location', 'MeetingsStore'];

        // collection of observables that we need to dispose
        private _subscribes: Rx.IDisposable[];

        constructor(private $location: angular.ILocationService, private meetingsStore: MeetingsStore) {
            // go to meeting url
            this._subscribes = [
                this.meetingsStore.activeMeeting$.subscribe((meeting) => {
                    // check if we are on the meetings page
                    if (this.$location.path().match(/\/meeting\/\d+\/?/i)) {
                        this.$location.url(`/meeting/${meeting?.id}/`);
                    }
                }),
            ];
        }

        $onDestroy() {
            this._subscribes.forEach((obs) => obs.dispose());
        }
    }

    angular.module('tradersyard').component('tyChatFullscreen', {
        // language=HTML
        template: `
            <ty-chat class="is-fullscreen"/>
        `,
        controller: ChatFullscreenComponent,
    });
})();
